import { useState } from "react";
import { useMutation, useQuery } from "convex/react";
import { SignedIn, SignedOut, SignInButton } from "@clerk/clerk-react";

import { api } from "../convex_api";

export function AgentConnectionsRoute() {
  return (
    <>
      <SignedOut>
        <main className="shell">
          <section className="card">
            <p className="eyebrow">CCLP Course — Connections</p>
            <h1>Sign in to manage your connections.</h1>
            <div style={{ marginTop: 20 }}>
              <SignInButton mode="modal">
                <button className="primary">Sign in</button>
              </SignInButton>
            </div>
          </section>
        </main>
      </SignedOut>
      <SignedIn>
        <ConnectionsList />
      </SignedIn>
    </>
  );
}

function ConnectionsList() {
  const clients = useQuery(api.oauth.listMyClients, {});
  const revoke = useMutation(api.oauth.revokeMyClient);
  const [pending, setPending] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);

  async function handleRevoke(clientId: string) {
    setPending(clientId);
    setError(null);
    try {
      await revoke({ clientId });
    } catch (err) {
      setError(err instanceof Error ? err.message : "Could not revoke this client.");
    } finally {
      setPending(null);
    }
  }

  return (
    <main className="shell">
      <section className="card">
        <p className="eyebrow">CCLP Course — Active connections</p>
        <h1>MCP connectors authorized for your account.</h1>
        <p className="hint">
          Each entry below represents a tool / client that holds an active access token. Revoking
          a connection invalidates its token immediately.
        </p>

        {error && <p className="error">{error}</p>}

        {clients === undefined ? (
          <p className="hint" style={{ marginTop: 16 }}>Loading…</p>
        ) : clients.length === 0 ? (
          <p className="hint" style={{ marginTop: 16 }}>
            No active connections. When you authorize an MCP client, it appears here.
          </p>
        ) : (
          <ul className="connections-list">
            {clients.map((c: any) => (
              <li key={c.clientId}>
                <strong>{c.clientName ?? "Unnamed client"}</strong>
                <div className="meta">
                  Issued: {new Date(c.issuedAt).toLocaleString()} ·{" "}
                  {c.lastUsedAt
                    ? `Last used: ${new Date(c.lastUsedAt).toLocaleString()}`
                    : "Not yet used"}
                  <br />
                  Active tokens: {c.activeTokenCount} · Scopes:{" "}
                  <code>{(c.scope ?? []).join(" ")}</code>
                </div>
                <button
                  onClick={() => handleRevoke(c.clientId)}
                  disabled={pending === c.clientId}
                >
                  {pending === c.clientId ? "Revoking…" : "Revoke"}
                </button>
              </li>
            ))}
          </ul>
        )}
      </section>
    </main>
  );
}
